import styled from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;
  overflow: auto hidden;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #e8e8e8;

  .BaseTable__header {
    background: #fafafa;
    border-bottom: 1px solid #e8e8e8;
  }

  .BaseTable__header-cell {
    padding: 0;
    font-size: 11px;
    color: #8c8c8c;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    font-weight: 600;
  }

  .BaseTable__row {
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #fafafa;
    }
  }

  .BaseTable {
    width: 100%;
    overflow: hidden !important;
  }

  .BaseTable__header,
  .BaseTable__body {
    width: 100%;
    overflow: hidden !important;
  }
`;

export const Row = styled.div`
  display: flex;
  min-width: fit-content;
  width: 100%;
  align-items: center;
  font-size: 14px;
  height: 100%;
`;

export const FullCell = styled.div`
  padding: 0 16px 0 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 1 1 0;
  min-width: 180px;
  font-weight: 600;
  font-size: 14px;
  color: #1a1a1a;
  line-height: 1.4;
  display: flex;
  align-items: center;
`;

export const Cell = styled.div<{ $flex?: number }>`
  padding: 0 16px;
  overflow: visible;
  flex: ${({ $flex }) => $flex ?? 1} 1 0;
  min-width: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

export const CellNumber = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  line-height: 1.3;
  flex-shrink: 0;
`;

export const CellPrimary = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #1a1a1a;
  white-space: nowrap;
`;

export const CellSecondary = styled.span`
  font-size: 13px;
  color: #8c8c8c;
  font-weight: 400;
  white-space: nowrap;
`;

export const CellWrapper = styled.div<{ $dodEnabled?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: ${({ $dodEnabled }) => ($dodEnabled ? '135px' : '80px')};
`;

export const HeaderRow = styled.div`
  display: flex;
  min-width: fit-content;
  width: 100%;
  height: 38px;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  align-items: center;
`;

export const HeaderCell = styled.div<{ $firstColumn?: boolean }>`
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: ${({ $firstColumn }) => ($firstColumn ? '18px' : '16px')};
`;

export const HeaderTitle = styled.span`
  font-weight: 600;
  font-size: 11px;
  color: #8c8c8c;
  text-transform: uppercase;
  letter-spacing: 0.7px;
`;

export const SparklineWrapper = styled.div`
  flex: 1;
  height: 40px;
  min-width: 0;
  overflow: hidden;
`;

export const TrendValue = styled.span<{ $positive?: boolean; $neutral?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 13px;
  font-weight: 600;
  padding: 1px 5px;
  border-radius: 3px;
  white-space: nowrap;
  flex-shrink: 0;
  color: ${({ $positive, $neutral }) => ($neutral ? '#8c8c8c' : $positive ? '#16a34a' : '#dc2626')};
  background: ${({ $positive, $neutral }) =>
    $neutral ? 'transparent' : $positive ? 'rgb(22 163 74 / 8%)' : 'rgb(220 38 38 / 8%)'};

  .anticon {
    font-size: 10px;
  }
`;

export const DragHandle = styled.div`
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  color: #000;
  cursor: grab;
  z-index: 10;
  padding: 6px;
  font-size: 18px;
  display: flex;
  align-items: center;

  &:hover {
    color: #8c8c8c;
  }

  &:active {
    cursor: grabbing;
  }
`;

export const DraggableRow = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  background: #fff;
`;

export const RowWrapper = styled.div`
  flex: 1;
  padding-left: 32px;
  height: 100%;
  display: flex;
  align-items: stretch;
`;
